module.exports = __webpack_public_path__ + "img/troca.9eac5729.svg";